import React from 'react';

import {NotificationSettings} from 'Components/Comms';

import SettingsLayout from 'Components/Layouts/SettingsLayout';

export default class NotificationSettingsPage extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <SettingsLayout title="My Notification Settings">
                <div className="p-6">
                    <h2 className="text-lg leading-6 font-medium text-gray-900">
                        Notification Settings
                    </h2>
                </div>

                <div className="p-6">
                    <NotificationSettings
                        admin={false}
                    />
                </div>
            </SettingsLayout>
        );
    }
}